import { render } from "./AIQFunctionBox.vue?vue&type=template&id=236b7240&scoped=true&lang=pug"
import script from "./AIQFunctionBox.vue?vue&type=script&lang=js"
export * from "./AIQFunctionBox.vue?vue&type=script&lang=js"

import "./AIQFunctionBox.vue?vue&type=style&index=0&id=236b7240&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236b7240"]])

export default __exports__